import React, { Component } from "react";
import { Range } from "rc-slider";
import "rc-slider/assets/index.css";

class Slider extends Component {
  render() {
    const labelStyle = {
      color: this.props.theme === "dark" ? "#fff" : "#5A4E5E"
    };
    const firstLabelStyle = { ...labelStyle, left: "3%" };
    const lastLabelStyle = { ...labelStyle, left: "97%" };
    return (
      <Range
        className="slider"
        marks={{
          0: { style: firstLabelStyle, label: 2016 },
          25: { style: labelStyle, label: 2017 },
          50: { style: labelStyle, label: 2018 },
          75: { style: labelStyle, label: 2019 },
          100: { style: lastLabelStyle, label: 2020 }
        }}
        dots={false}
        defaultValue={[25, 50]}
        step={null}
        dotStyle={{ display: "none" }}
      />
    );
  }
}

export default Slider;
